import { render, staticRenderFns } from "./TournamentMainEventCard.vue?vue&type=template&id=02ee10f2&scoped=true&"
import script from "./TournamentMainEventCard.vue?vue&type=script&lang=js&"
export * from "./TournamentMainEventCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ee10f2",
  null
  
)

export default component.exports